import { isHttpStatusOK, parseFailed } from '@/apis/utils';
import { getEnv, Auth } from '@/utils';

const { GO_ENDPOINT } = getEnv();

async function getShopOnboardingLink(userId) {
  try {
    const token = await Auth.getIdToken();
    const response = await fetch(
      `${GO_ENDPOINT}/v1/users/${userId}/shop/onboarding_link`,
      {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (isHttpStatusOK(response.status)) {
      const data = await response.json();
      return data; // { onboarding_url: "https://..." }
    }

    const responseJson = await response.json();
    throw new Error(parseFailed(responseJson.errors[0]));
  } catch (error) {
    return error;
  }
}

export default getShopOnboardingLink;
